module.exports = __webpack_public_path__ + "static/media/driver-license.c8403e61.jpg";